export enum CatalogProductStatus {
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified'
}
